import confluenceSvg from './logos/confluence.svg?no-inline';
import dropboxSvg from './logos/dropbox.svg?no-inline';
import gmailSvg from './logos/gmail.svg?no-inline';
import googleCalendarSvg from './logos/google-calendar.svg?no-inline';
import googleDriveSvg from './logos/google-drive.svg?no-inline';

/**
 * The logos this client bundles (`./logos/`, its README names their source), by the catalog's
 * `logo.key`. Imported, never inlined, so the build serves each under `/assets/` with a hashed name.
 */
export const LOGO_ASSETS: ReadonlyMap<string, string> = new Map([
  ['confluence', confluenceSvg],
  ['dropbox', dropboxSvg],
  ['gmail', gmailSvg],
  ['google-calendar', googleCalendarSvg],
  ['google-drive', googleDriveSvg],
]);

/**
 * The catalog's `logo.key` of each service, for a card drawn without a catalog read (a record
 * never queries).
 */
export const SERVICE_LOGO_KEYS: Readonly<Record<string, string>> = {
  outlook: 'outlook',
  teams: 'microsoft-teams',
  confluence: 'confluence',
  docusign: 'docusign',
  dropbox: 'dropbox',
  gmail: 'gmail',
  google_calendar: 'google-calendar',
  google_drive: 'google-drive',
};

const HEX_COLOUR = /^#[0-9a-fA-F]{3,8}$/;

/** The catalog's `brandColor` when it is a hex colour, else undefined. */
export function brandColour(value: string | undefined): string | undefined {
  return value && HEX_COLOUR.test(value) ? value : undefined;
}
